import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LifeBuoy, ArrowLeft } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

/**
 * Persistent, visually distinct banner shown whenever Platform Admin support
 * mode is active. Makes it unmistakable that the current team is a customer
 * team being administrated as Platform Admin — never one of "Mina lag".
 */
export const SupportModeBanner = () => {
  const navigate = useNavigate();
  const { isSupportMode, supportContext, exitSupportMode } = useAuth();

  if (!isSupportMode || !supportContext) return null;

  const teamName = supportContext.team?.name || 'Lag';
  const orgName = supportContext.team?.organization_name || 'föreningen';

  const handleBack = () => {
    const orgId = supportContext.orgId;
    exitSupportMode();
    navigate(orgId ? `/platform-admin/orgs/${orgId}` : '/platform-admin/orgs');
  };

  return (
    <div
      data-testid="support-mode-banner"
      className="flex items-center justify-between gap-3 px-4 py-2 bg-amber-500/15 border-b-2 border-amber-500/60 text-[rgb(var(--tn-text-fef3c7))]"
    >
      <div className="flex items-center gap-2 min-w-0">
        <LifeBuoy className="w-4 h-4 flex-shrink-0 text-[rgb(var(--tn-text-fbbf24))]" />
        <span className="text-sm font-semibold truncate">Supportläge · {teamName}</span>
        <span className="hidden sm:inline text-xs text-[rgb(var(--tn-text-fde68a))]/80 truncate">
          Du administrerar laget som Platform Admin.
        </span>
      </div>
      <button
        type="button"
        onClick={handleBack}
        data-testid="support-mode-back-btn"
        className="flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded bg-amber-500/25 hover:bg-amber-500/40 transition flex-shrink-0"
      >
        <ArrowLeft className="w-3.5 h-3.5" />
        Tillbaka till {orgName}
      </button>
    </div>
  );
};

export default SupportModeBanner;
